import styled from '@emotion/styled';

import { button, input, maxWidthAndCenter } from '@styles';

import { IBookingFormProps } from './index';

const CtaFormContainer = styled.div<Pick<IBookingFormProps, 'hasBackdrop'>>`
  position: relative;
  background: var(--orange);
  overflow: hidden;

  .cta_form__form {
    ${maxWidthAndCenter}
    padding: 3rem 0;
    position: ${(props) => (props.hasBackdrop ? 'absolute' : 'initial')};
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
  }

  .cta_form__title {
    padding: 0 0 1.5rem;
    font-size: 2.5rem;
    color: var(--blue);
    font-weight: 900;
    text-align: center;
    line-height: 1;
  }

  .cta_form__content {
    padding: 0 0 2rem;
    font-size: 1.25rem;
    color: white;
    text-align: center;
  }

  .cta_form__row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 0 1rem;

    & > div input:nth-of-type(2) {
      margin: 0 0 1rem 0;
    }
  }

  .cta_form__row:nth-of-type(2) {
    margin: 0 0 2rem;
  }

  .cta_form__row:last-of-type {
    margin: 0;
  }

  .cta_form__button {
    margin: 0 0 0;
    max-width: 100%;
    min-width: 30rem;
    ${button('blue')}
  }

  .cta_form__input {
    ${input()}
  }

  .cta_form__image__wrapper {
    max-height: 45rem;
    filter: contrast(1.05) grayscale();
    mix-blend-mode: hard-light;
  }

  .cta_form__image__gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      rgba(244, 120, 32, 1) 0%,
      rgba(244, 120, 32, 1) 40%,
      rgba(125, 185, 232, 0) 100%
    );
    z-index: 1;
  }

  @media screen and (max-width: 1470px) {
    .cta_form__title {
      padding: 0 2rem 1.5rem;
    }
  }

  @media screen and (max-width: 1024px) {
    .cta_form__image {
      display: none;
      visibility: hidden;
    }

    .cta_form__form {
      position: initial;
    }

    .cta_form__title {
      font-size: 2rem;
    }

    .cta_form__content {
      padding: 0 2rem 2rem;
    }

    .cta_form__row {
      margin: 0;
      padding: 0 2rem;
      flex-direction: column;
      align-items: center;

      &:nth-of-type(2) {
        margin: 0;
      }

      input {
        max-width: 25rem;
        min-width: auto;
        width: 100%;
        margin: 0 0 1.5rem;
      }
    }

    .cta_form__button {
      min-width: auto;
    }
  }
`;

const CtaHiddenInput = styled.input`
  position: absolute;
  top: -9000px;
  left: -9000px;
`;

export { CtaFormContainer, CtaHiddenInput };
